import React from "react";
import styled from "styled-components";

export default function FullButton({ title, action, border, icon }) {
  return (
    <Wrapper
      className="animate pointer radius8"
      onClick={action ? () => action() : null}
      border={border}
    >
      {icon && <IconSlot>{icon}</IconSlot>}
      {title}
    </Wrapper>
  );
}

const IconSlot = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`;

const Wrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid ${(props) => (props.border ? "#707070" : "rgb(119, 31, 115)")};
  background-color: ${(props) => (props.border ? "transparent" : "rgb(119, 31, 115)")};
  width: 100%;
  padding: 15px;
  outline: none;
  color: ${(props) => (props.border ? "#707070" : "#fff")};
  box-shadow: ${(props) => (props.border ? "none" : "0 6px 16px rgba(119, 31, 115, 0.25)")};
  transform: translateY(0);
  :hover {
    background-color: ${(props) => (props.border ? "rgba(119, 31, 115, 0.06)" : "rgb(98, 25, 94)")};
    border: 1px solid rgb(119, 31, 115);
    color: ${(props) => (props.border ? "rgb(119, 31, 115)" : "#fff")};
    transform: translateY(-2px);
    box-shadow: ${(props) => (props.border ? "0 6px 16px rgba(11, 9, 59, 0.08)" : "0 10px 20px rgba(119, 31, 115, 0.3)")};
  }
`;

